import { useEffect, useState } from 'react';
import { buildActivityWsUrl } from './buildActivityWsUrl';

const RECONNECT_MS = 4000;

export function useActivityWebSocket(): string | null {
  const [lastTitle, setLastTitle] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      return undefined;
    }

    let ws: WebSocket | null = null;
    let reconnectTimer: ReturnType<typeof setTimeout> | null = null;
    let cancelled = false;

    const connect = () => {
      if (cancelled) return;
      try {
        const url = buildActivityWsUrl(token);
        ws = new WebSocket(url);
      } catch {
        scheduleReconnect();
        return;
      }

      ws.onmessage = (ev: MessageEvent<string>) => {
        try {
          const data = JSON.parse(ev.data) as { title?: string };
          if (typeof data.title === 'string') {
            setLastTitle(data.title);
          }
        } catch {
          /* ignore malformed */
        }
      };

      ws.onclose = () => {
        ws = null;
        if (!cancelled) scheduleReconnect();
      };

      ws.onerror = () => {
        ws?.close();
      };
    };

    const scheduleReconnect = () => {
      if (cancelled || reconnectTimer) return;
      reconnectTimer = window.setTimeout(() => {
        reconnectTimer = null;
        connect();
      }, RECONNECT_MS);
    };

    connect();

    return () => {
      cancelled = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      ws?.close();
    };
  }, []);

  return lastTitle;
}
